import React from 'react';
import Icon from '@/components/ui/AppIcon';

const TrustIndicators: React.FC = () => {
  const securityFeatures = [
    {
      icon: 'UserGroupIcon',
      title: 'Professional Confidentiality',
      description: 'All institutional inquiries are reviewed personally by senior advisors, not automated systems.',
    },
    {
      icon: 'ShieldCheckIcon',
      title: 'Discreet Institutional Engagement',
      description: 'We understand the sensitive nature of organizational transformation discussions and maintain strict professional discretion.',
    },
    {
      icon: 'DocumentCheckIcon',
      title: 'Ethical Advisory Standards',
      description: 'All inquiries are treated with professional confidentiality appropriate for government and public sector engagements.',
    },
    {
      icon: 'ClockIcon',
      title: 'Thoughtful Review Process',
      description: 'Every conversation request receives careful consideration for strategic alignment and partnership potential.',
    },
  ];

  const commitments = [
    'No unsolicited marketing or sales pressure',
    'Transparent discussion of our approach and methodology',
    'Honest assessment of mutual fit and engagement potential',
    'Respect for your institutional decision-making processes',
    'Long-term value focus over short-term transactions',
  ];

  return (
    <div className="space-y-8">
      <div>
        <h2 className="text-2xl lg:text-3xl font-bold text-text-primary mb-4">
          Our Commitment to You
        </h2>
        <p className="text-text-secondary leading-relaxed">
          We understand that reaching out for strategic advisory support requires trust and confidence. Here is what you can expect from Diaax Advisory.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {securityFeatures.map((feature, index) => (
          <div
            key={index}
            className="bg-white rounded-lg institutional-shadow p-6 hover:shadow-xl transition-institutional"
          >
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 bg-success/10 rounded-lg flex items-center justify-center flex-shrink-0">
                <Icon name={feature.icon as any} size={24} className="text-success" />
              </div>
              <div>
                <h3 className="font-semibold text-text-primary mb-2">{feature.title}</h3>
                <p className="text-sm text-text-secondary leading-relaxed">
                  {feature.description}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="bg-white rounded-lg institutional-shadow p-8">
        <h3 className="text-xl font-semibold text-text-primary mb-6 institutional-accent-border pl-4">
          Our Professional Standards
        </h3>
        <ul className="space-y-4">
          {commitments.map((commitment, index) => (
            <li key={index} className="flex items-start gap-3">
              <Icon
                name="CheckCircleIcon"
                size={20}
                className="text-institutional flex-shrink-0 mt-0.5"
                variant="solid"
              />
              <span className="text-text-secondary">{commitment}</span>
            </li>
          ))}
        </ul>
      </div>

      <div className="bg-white rounded-lg institutional-shadow p-8">
        <div className="flex items-start gap-4">
          <Icon name="InformationCircleIcon" size={28} className="flex-shrink-0 mt-1 text-institutional" variant="solid" />
          <div>
            <h3 className="text-xl font-semibold mb-3 text-institutional">
              Why Institutions Choose Diaax
            </h3>
            <p className="text-gray-700 leading-relaxed mb-4">
              We are a senior advisory-led practice that combines strategic depth with practical execution support. Unlike large consulting firms, you work directly with senior advisors who understand institutional complexity and political realities. Unlike training companies, we focus on building sustainable organizational capabilities alongside strategic planning.
            </p>
            <p className="text-gray-700 leading-relaxed">
              Our selective approach means we work only with institutions committed to genuine transformation, ensuring we can provide the focused attention and long-term partnership your organization deserves.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrustIndicators;